module.exports = __webpack_public_path__ + "assets/img/sy_5g_1_djzy.c3685e5d.png";